import { logStatus } from "../utils";
const keyConversions = {
    "spacebar": "space",
    bs: "Backspace",
    bksp: "Backspace",
    shift: "Shift",
    shft: "Shift",
    lshift: "Shift",
    lshft: "Shift",
    "left shift": "Shift",
    leftshift: "Shift",
    rshift: "Shift",
    rshft: "Shift",
    "right shift": "Shift",
    rightshift: "Shift",
    commandorcontrol: "CommandOrControl",
    alternate: "Alt",
    "space bar": "space",
    pgup: "PageUp",
    "pg up": "PageUp",
    "page down": "PageDown",
    pgdn: "PageDown",
    "pg dn": "PageDown",
    pgdown: "PageDown",
    "left arrow": "Left",
    left: "Left",
    "up arrow": "Up",
    up: "Up",
    "right arrow": "Right",
    right: "Right",
    "down arrow": "Down",
    down: "Down",
    print: "PrintScreen",
    prnt: "PrintScreen",
    "print screen": "PrintScreen",
    printscreen: "PrintScreen",
    "print scrn": "PrintScreen",
    printscrn: "PrintScreen",
    "prnt scrn": "PrintScreen",
    prntscrn: "PrintScreen",
    "prt scrn": "PrintScreen",
    prtscrn: "PrintScreen",
    "prt scn": "PrintScreen",
    prtscn: "PrintScreen",
    "prt scr": "PrintScreen",
    prtscr: "PrintScreen",
    "prt sc": "PrintScreen",
    prtsc: "PrintScreen",
    "pr sc": "PrintScreen",
    prsc: "PrintScreen",
    insert: "Insert",
    ins: "Insert",
    delete: "Delete",
    del: "Delete",
    0: "0",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
    windows: "Super",
    "left windows": "Super",
    "right windows": "Super",
    "numpad 0": "num0",
    "numpad 1": "num1",
    "numpad 2": "num2",
    "numpad 3": "num3",
    "numpad 4": "num4",
    "numpad 5": "num5",
    "numpad 6": "num6",
    "numpad 7": "num7",
    "numpad 8": "num8",
    "numpad 9": "num9",
    f1: "F1",
    fn1: "F1",
    "function 1": "F1",
    f2: "F2",
    fn2: "F2",
    "function 2": "F2",
    f3: "F3",
    fn3: "F3",
    "function 3": "F3",
    f4: "F4",
    fn4: "F4",
    "function 4": "F4",
    f5: "F5",
    fn5: "F5",
    "function 5": "F5",
    f6: "F6",
    fn6: "F6",
    "function 6": "F6",
    f7: "F7",
    fn7: "F7",
    "function 7": "F7",
    f8: "F8",
    fn8: "F8",
    "function 8": "F8",
    f9: "F9",
    fn9: "F9",
    "function 9": "F9",
    f10: "F10",
    fn10: "F10",
    "function 10": "F10",
    f11: "F11",
    fn11: "F11",
    "function 11": "F11",
    f12: "F12",
    fn12: "F12",
    "function 12": "F12",
    f13: "F13",
    fn: "F13",
    "function 13": "F13",
    f14: "F14",
    fn14: "F14",
    "function 14": "F14",
    f15: "F15",
    fn15: "F15",
    "function 15": "F15",
    f16: "F16",
    fn16: "F16",
    "function 16": "F16",
    "num lock": "Numlock",
    numlock: "Numlock",
    "number lock": "Numlock",
    "numeric lock": "Numlock",
    "scroll lock": "Scrolllock",
    sclk: "Scrolllock",
    scrlk: "Scrolllock",
    slk: "Scrolllock",
    "*": "*",
    "+": "+",
    "-": "-",
    "/": "/",
    ";": ";",
    "=": "=",
    ",": ",",
    ".": ".",
    "`": "`",
    "[": "[",
    "]": "]",
    "'": "'",
};
export const convertFinsembleKeyArrToGlueKeyString = (keyArr) => {
    return keyArr.map((k) => keyConversions[k.toString().toLowerCase()] ?? k).join("+").replace(/windows/i, "super")
        .replace(/spacebar/i, "space");
};
export class HotkeyClientImpl {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.gluePromise = gluePromise;
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "HotkeyClient",
            method, type, data
        });
    }
    onClose(cb) {
        this.removeAllHotkeys(cb);
    }
    async removeAllHotkeys(cb) {
        this.logStatus("removeAllHotkeys", "start");
        await this.asyncConstructors.ready();
        await this.glue.hotkeys.unregisterAll();
        this.logStatus("removeAllHotkeys", "return", { err: null });
        cb?.(null);
        return {
            err: null
        };
    }
    async removeGlobalHotkey(keyArr, handler, cb) {
        this.logStatus("removeGlobalHotkey", "start", { keyArr });
        await this.asyncConstructors.ready();
        await this.glue.hotkeys.unregister(convertFinsembleKeyArrToGlueKeyString(keyArr));
        this.logStatus("removeGlobalHotkey", "return");
        cb?.(null);
        return {
            err: null
        };
    }
    async addGlobalHotkey(keyArr, handler, cb) {
        this.logStatus("addGlobalHotkey", "start", keyArr);
        await this.asyncConstructors.ready();
        const glueKeyString = convertFinsembleKeyArrToGlueKeyString(keyArr);
        await this.glue.hotkeys.register(glueKeyString, () => {
            this.loggerClient.debug("Got hotkey", glueKeyString);
            handler();
        });
        this.logStatus("addGlobalHotkey", "return");
        cb?.(null);
        return {
            err: null
        };
    }
    addBrowserHotkey(keyArr, handler, addedByUser) {
        console.warn("The method addBrowserHotkey() has been deprecated. Use local keypress event handlers instead.");
    }
}
